import { dateFormatMap } from '@op/constants';
import {
  dealwithLanguage,
  formatTime,
  toPercentNumber,
} from '../../render-helper';

export default function (params: any) {
  const { date_type } = params;
  return [
    {
      renderHelper: [formatTime(dateFormatMap[date_type])],
      header: 'Date',
      render: 'time',
    },
    {
      renderHelper: [dealwithLanguage],
      header: 'Language',
      render: 'language',
    },
    {
      header: 'Positive',
      render: 'positive',
    },
    {
      header: 'Negative',
      render: 'negative',
    },
    {
      header: `Positive%`,
      render: 'score',
      renderHelper: [toPercentNumber(true)],
      numFmt: '0.00%',
    },
  ];
}
